// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"e0e65016","129":"f5764d31","389":"a39b6fac","403":"b836afeb","440":"353f58ff","491":"dab4bdfc","517":"446cdc7c","787":"226c7464","866":"d6b46874","986":"289fd66a"}[chunkId] + ".chunk.js";
};